import React from 'react';
import { motion } from 'framer-motion';
interface TrailConnectorProps {
  direction: 'left-to-right' | 'right-to-left' | 'straight';
  colorClass: string;
}
export function TrailConnector({
  direction,
  colorClass
}: TrailConnectorProps) {
  // Extract a base color for the stroke, defaulting to a slate color if not found
  const strokeColor = colorClass.includes('blue') ? '#93C5FD' : colorClass.includes('rose') ? '#FDA4AF' : colorClass.includes('emerald') ? '#6EE7B7' : '#CBD5E1';
  return <div className="w-full h-16 sm:h-24 relative -my-4 sm:-my-6 z-0 pointer-events-none flex justify-center" data-id="element-1883">
      <svg className="w-3/4 h-full overflow-visible" preserveAspectRatio="none" viewBox="0 0 100 100" data-id="element-1884">
        <motion.path initial={{
        pathLength: 0,
        opacity: 0
      }} animate={{
        pathLength: 1,
        opacity: 1
      }} transition={{
        duration: 1,
        ease: 'easeInOut'
      }} d={direction === 'left-to-right' ? 'M 20,0 C 20,50 80,50 80,100' : direction === 'right-to-left' ? 'M 80,0 C 80,50 20,50 20,100' : 'M 50,0 L 50,100'} fill="none" stroke={strokeColor} strokeWidth="8" strokeLinecap="round" strokeDasharray="12 12" className="drop-shadow-sm" data-id="element-1885" />
      </svg>
    </div>;
}